import * as React from "react"
import { Link } from "gatsby"

export default function Breadcrumb({ paths }) {
  return (
    <p className="mt-10 text-primary">
      <Link to="/">Accueil</Link>
      {paths.map(path => <>
        <span className="mx-3 opacity-50">{'//'}</span>
        {path.url === null &&
          <span aria-current="page" className="text-white opacity-75">{path.name}</span>
        }
        {path.url !== null &&
          <Link to={path.url}>{path.name}</Link>
        }
      </>)}
    </p>
  )
}
